module.exports = __webpack_public_path__ + "img/resume-img.9eff846f.jpg";